const CustomCursor = require('custom-cursor.js').default

const cursorEl = document.createElement('div');
cursorEl.setAttribute('class', 'main-cursor');
const cursorInnerEl = document.createElement('div');
cursorInnerEl.setAttribute('class', 'cursor-border');
cursorEl.append(cursorInnerEl);
document.body.prepend(cursorEl);

const customCursor = new CustomCursor('.main-cursor', {
    hideTrueCursor: true,

// {
//     selector: '.project-video-bg',
//         focusClass: 'cursor--hidden-view'
// },
    focusElements: [
        'a',
        'button',
    ],
    focusClass: 'cursor--focused',
}).setPosition(-30, -30).initialize()

